import * as vp from 'vopay';
import React, { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import AccountCreationContext from './AccountCreationContext';
import HubSpotSection from './HubSpotSection';

const { Box, Icon, SubTitle, Table } = vp;

export type SectionProps = {
  sectionId: string;
  showSubLabels?: boolean;
  showHubSpotButton?: boolean;
};

type FC = FunctionComponent<SectionProps>;

const MultiStepSection: FC = ({ sectionId, showSubLabels = false, showHubSpotButton = false }: SectionProps) => {
  const ctx = useContext(AccountCreationContext);
  const { getErrorElementsBySection, isRequiredField, getSection } = ctx.fields;
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  return (
    <Box mb="lg" flx="col">
      <HubSpotSection showHubSpotButton={showHubSpotButton} />
      {getErrorElementsBySection(sectionId, ctx)}
      {getSection(sectionId).map(({ label, fields, showSection }) => {
        return showSection(ctx) ? (
          <Box key={`${sectionId}-${label}`} mb="lg" flx="col">
            {showSubLabels && <SubTitle subTitle={label} />}
            <Table
              {...{
                name: `billing-package-creation-${sectionId}`,
                variant: 'pair',
                columns: {
                  key: { header: tGlobal('Tables.key') },
                  input: { header: tGlobal('Tables.input') },
                },
                rows: (Object.keys(fields) as (keyof typeof fields)[])
                  .filter((fieldName) => runFilter(fieldName))
                  .map((fieldName) => ({
                    key: (
                      <Box ai="center">
                        {fields ? fields[fieldName]?.label : ''}
                        {getRequiredIcon(fieldName)}
                        {getToolTip(fieldName)}
                      </Box>
                    ),
                    input: getElement(fieldName),
                  })),
              }}
            />
          </Box>
        ) : (
          <div />
        );

        function runFilter(fieldName: keyof typeof fields): boolean {
          return Boolean(fields[fieldName]?.showField(ctx));
        }

        function getElement(fieldName: keyof typeof fields): React.JSX.Element | string {
          return fields[fieldName]?.getElement(ctx) || '';
        }

        function getToolTip(fieldName: keyof typeof fields): React.JSX.Element | string {
          return fields[fieldName]?.toolTip?.(ctx) || '';
        }

        function getRequiredIcon(fieldName: keyof typeof fields): React.JSX.Element {
          return isRequiredField(sectionId, fieldName, ctx) ? <Icon icon="asterisk" size="xsm" color="error" /> : <></>;
        }
      })}
    </Box>
  );
};

export default MultiStepSection;
